// extracted by mini-css-extract-plugin
export default {"SubSection":"WildlifeManagement-PDF-style_SubSection__l1ytD","Disclaimer":"WildlifeManagement-PDF-style_Disclaimer__no-ri","Bordered":"WildlifeManagement-PDF-style_Bordered__oLdm0"};